import ajax from './public'

export function getBanner(params) { //公司产品列表接口
	return ajax.fetchGet('/banner-list', params)
}

export function getZiyuan(params) {
	return ajax.fetchGet('/source-list', params)
}

export function getCustomerList(params) {
	return ajax.fetchGet('/customer-list', params)
}

export function getCompany(params){
	return ajax.fetchGet('/company', params)
}

export function addApply(params) {
	return ajax.fetchPost('/apply', params)
}

export function getDemelist(params) {
	return ajax.fetchGet('/demeanor-list', params)
}

export function joinUs(params) {
	return ajax.fetchGet('/join-list', params)
}



// WEBPACK FOOTER //
// ./src/api/user.js